import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import { EmbeddedAppContactSupportLink } from '../EmbeddedAppContactSupportLink';
import styles from './index.module.css';

export type EmbeddedAppUnprocessableProps = {
  embeddedAppStatus: EmbeddedAppStates;
};

export const EmbeddedAppUnprocessable = ({
  embeddedAppStatus,
}: EmbeddedAppUnprocessableProps) => {
  const { t } = useTranslation();

  if (
    embeddedAppStatus !== 'UNPROCESSABLE' &&
    embeddedAppStatus !== 'INVALID_URL'
  )
    return <></>;

  return (
    <div className={styles.root}>
      <div
        className={classNames('base-margin-bottom', styles.heading)}
        role="heading"
        aria-level={2}
      >
        {t('sessions.tabs.launchPanel.unprocessable.feedback.heading')}
      </div>
      <p className="base-margin-bottom">
        {t('sessions.tabs.launchPanel.unprocessable.feedback.message1')}
        <br />
        {t('sessions.tabs.launchPanel.unprocessable.feedback.message2')}
      </p>
      <EmbeddedAppContactSupportLink />
    </div>
  );
};
